module.exports = __webpack_public_path__ + "static/img/qr_code.44f54c58.jpg";